import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "label"]

  loading() {
    this.spinnerTarget.classList.remove("hidden")
    this.element.disabled = true
  }
} 